import React from "react";
import { Text } from "@networkraildigitalfactory/components";
import { useDropzone } from "react-dropzone";
import { UploadSimple, File, FileText, Image, VideoCamera, Trash } from "phosphor-react";
import styles from "./FileUpload.module.css";

export const getFileIcon = (type) => {
  let icon;
  const fileType = type?.split("/")[0];
  const iconProps = { size: 20, color: "#37519D" };
  switch (fileType) {
    case "image":
      icon = <Image style={{ minWidth: "24px", minHeight: "24px" }} {...iconProps} />;
      break;
    case "application":
      icon = <FileText style={{ minWidth: "24px", minHeight: "24px" }} {...iconProps} />;
      break;
    case "text":
      icon = <FileText style={{ minWidth: "24px", minHeight: "24px" }} {...iconProps} />;
      break;
    case "video":
      icon = <VideoCamera style={{ minWidth: "24px", minHeight: "24px" }} {...iconProps} />;
      break;
    default:
      icon = <File style={{ minWidth: "24px", minHeight: "24px" }} {...iconProps} />;
  }
  return icon;
};

export const FileUpload = (props) => {
  const { onAddFiles, files, onRemoveFiles } = props;
  const onDrop = (acceptedFiles) => onAddFiles(acceptedFiles);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <>
      <div {...getRootProps()}>
        <input
          type="file"
          {...getInputProps({
            accept: "application/*, application/vnd.ms-outlook, image/*, video/*, .msg",
          })}
        />
        <div className={styles.fileUpload_row} style={{ marginBottom: "10px" }}>
          <UploadSimple color="#37519D" size={28} />
          <Text
            wrapper="h2"
            type="header"
            style={{
              fontSize: "20px",
              cursor: "pointer",
              textDecoration: "underline",
              margin: "0 0 0 10px",
            }}
          >
            Upload evidence
          </Text>
        </div>
      </div>
      {files &&
        files.map((file, index) => {
          const fileName = file.name || file.fileName;
          const fileType = file.type || file.fileType;
          const fileSize = file.size ?? file.fileSize;
          const fileMBSize = (fileSize / 1024 / 1024).toFixed(2);
          return (
            <div key={index} className={styles.evidenceFiles}>
              {getFileIcon(fileType)}
              <Text wrapper="span" type="body">
                {fileName}
              </Text>
              <Text wrapper="span" type="body">
                {fileMBSize} MB
              </Text>
              <Trash
                role="button"
                tabIndex={0}
                style={{ cursor: "pointer", minWidth: "24px", minHeight: "24px" }}
                onClick={(e) => {
                  onRemoveFiles(e, index, file);
                }}
                color="#ff0000"
              />
            </div>
          );
        })}
    </>
  );
};
